export default __webpack_public_path__ + "static/media/arrow_eval_down.bbb35771.svg";